var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.rolesArray),function(role){return _c('b-tag',{key:role.access,attrs:{"closable":_vm.deletable},on:{"close":function($event){return _vm.close($event)}}},[_vm._v(" "+_vm._s(_vm.getRoleDisplay(role.role))+":"+_vm._s(_vm.getAccessDisplay(role.access))+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }